module.exports = __webpack_public_path__ + "img/founders_06.ae82f01c.jpg";